import { ReactNode } from 'react';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <header>
        <img src="/assets/logo_black.svg" alt="MANGA MILLION" width="115" height="34" />
      </header>
      <main>
        {children}
      </main>
      <footer>
        <div className="footer-top">
          <img src="/assets/logo_white.svg" alt="MANGA MILLION" width="115" height="34" />
          <p className="copyright pc">©︎2026 Shueisha Inc. All rights reserved.</p>
        </div>
        <div className="footer-bottom">
          {/* ABJ マークは認可され次第表示する。認可後にこのコメントアウトを解除すること */}
          {/* <div className="footer-abj">
            <img src="/assets/abj.svg" alt="ABJ Mark" width="48" height="48" />
            <p>
              ABJ Mark is a registered trademark (Registration No.10921042) Indicating that this
              e-book store / e-book distribution service is an authorized distribution service
              that gained permission to use content from the copyright holder. For more information
              check https://aebs.or.jp/.
            </p>
          </div> */}
          <p className="copyright sp">©︎2026 Shueisha Inc. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
}
